'use client'
import ProductLayout from '../product-layout'

export default function Overview({ projectData, id }) {
  return (
    <ProductLayout id={id} projectData={projectData}>
      <div
        className="overflow-hidden text-white editor-words"
        dangerouslySetInnerHTML={{
          __html: projectData?.companyData?.company_overview || '',
        }}
      />
    </ProductLayout>
  )
}
